/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface FormateurAgrementSearch
 */
export interface FormateurAgrementSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurAgrementSearch
     */
    idFormateur?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurAgrementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurAgrementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurAgrementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurAgrementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurAgrementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurAgrementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurAgrementSearch interface.
 */
export function instanceOfFormateurAgrementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurAgrementSearchFromJSON(json: any): FormateurAgrementSearch {
    return FormateurAgrementSearchFromJSONTyped(json, false);
}

export function FormateurAgrementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurAgrementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurAgrementSearchToJSON(value?: FormateurAgrementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFormateur': value.idFormateur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

